/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive} from '@angular/core';
/**
 * The floating placeholder for an `MdFormField`.
 */
export class MdPlaceholder {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-placeholder, mat-placeholder'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdPlaceholder_tsickle_Closure_declarations() {
/** @type {?} */
MdPlaceholder.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdPlaceholder.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
